<p class="text-lg font-medium">Confirmation</p>
<p class="text-secondary mb-6">
  {{ message }}
</p>

<div class="flex items-center justify-end -mx-8 mt-5 px-8 py-5">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button class="px-6 ml-3" (click)="onOkClick()" mat-flat-button [color]="'primary'">Ok</button>
</div>
